import { selectModalOptions, useDappSelector } from "#/redux-state"
import { MezoModalProps } from "#/shared/types"
import { StepperModal } from "#/ui/Modal"

import AddLiquidityFlowProvider from "./AddLiquidityFlowContext"
import AddLiquidityFormStep from "./AddLiquidityFormStep"
import ApproveAssets from "./ApproveAssets"
import ClaimingRewards from "./ClaimingRewards"
import LiquidityAdded from "./LiquidityAdded"
import RewardsClaimed from "./RewardsClaimed"
import SelectPoolStep from "./SelectPool"
import WaitingForTransaction from "./WaitingForTransaction"

export default function AddLiquidityModal(props: MezoModalProps) {
  // TODO: Add `Stepper` component to the `StepperModal`.
  // @ts-expect-error how to improve typings?
  const { selectedPoolId } = useDappSelector(selectModalOptions)

  return (
    <AddLiquidityFlowProvider initialPoolId={selectedPoolId}>
      <StepperModal
        {...props}
        numberOfStepsInStepper={3}
        steps={[
          {
            component: SelectPoolStep,
            title: "Add Liquidity",
            withStepIndicator: true,
            withCloseButton: true,
          },
          {
            component: AddLiquidityFormStep,
            title: "Add Liquidity",
            withStepIndicator: true,
          },
          {
            component: ApproveAssets,
            title: "Add Liquidity",
            withStepIndicator: true,
          },
          { component: WaitingForTransaction, title: "Approve & Deposit" },
          {
            component: LiquidityAdded,
            title: "Success",
            withCloseButton: false,
            withBackButton: false,
          },
          { component: ClaimingRewards, withBackButton: false },
          { component: RewardsClaimed, withBackButton: false },
        ]}
      />
    </AddLiquidityFlowProvider>
  )
}
